var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlinkFormat(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 5.3125C7.72671 5.3125 8.0625 5.64829 8.0625 6.0625C8.0625 6.47671 7.72671 6.8125 7.3125 6.8125H6.8125C5.00032 6.8125 3.53125 8.28157 3.53125 10.0938C3.53125 11.9059 5.00032 13.375 6.8125 13.375H7.3125C7.72671 13.375 8.0625 13.7108 8.0625 14.125C8.0625 14.5392 7.72671 14.875 7.3125 14.875H6.8125C4.17189 14.875 2.03125 12.7344 2.03125 10.0938C2.03125 7.45314 4.17189 5.3125 6.8125 5.3125H7.3125ZM13.1875 5.3125C15.8281 5.3125 17.9688 7.45314 17.9688 10.0938C17.9688 12.7344 15.8281 14.875 13.1875 14.875H12.7188C12.3045 14.875 11.9688 14.5392 11.9688 14.125C11.9688 13.7108 12.3045 13.375 12.7188 13.375H13.1875C14.9997 13.375 16.4688 11.9059 16.4688 10.0938C16.4688 8.28157 14.9997 6.8125 13.1875 6.8125H12.7188C12.3045 6.8125 11.9688 6.47671 11.9688 6.0625C11.9688 5.64829 12.3045 5.3125 12.7188 5.3125H13.1875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkFormat);
export default __webpack_public_path__ + "static/media/unlink-format.1f899998.svg";
export { ForwardRef as ReactComponent };